export const featuredMatches = [
  {
    id: 'm1',
    sport: 'Football',
    league: 'Premier League',
    leagueFlag: '🏴󠁧󠁢󠁥󠁮󠁧󠁿',
    homeTeam: 'Manchester City',
    awayTeam: 'Arsenal',
    homeIcon: '🔵',
    awayIcon: '🔴',
    date: 'Auj. 20:45',
    markets: {
      home: 1.85,
      draw: 3.50,
      away: 4.20,
    },
    popular: true,
    hot: true,
  },
  {
    id: 'm2',
    sport: 'Football',
    league: 'Ligue 1',
    leagueFlag: '🇫🇷',
    homeTeam: 'PSG',
    awayTeam: 'Marseille',
    homeIcon: '🔵',
    awayIcon: '⚪',
    date: 'Auj. 21:00',
    markets: {
      home: 1.60,
      draw: 3.80,
      away: 5.50,
    },
    popular: true,
    hot: false,
  },
  {
    id: 'm3',
    sport: 'Football',
    league: 'Champions League',
    leagueFlag: '🌟',
    homeTeam: 'Real Madrid',
    awayTeam: 'Bayern Munich',
    homeIcon: '⚪',
    awayIcon: '🔴',
    date: 'Dem. 21:00',
    markets: {
      home: 2.10,
      draw: 3.40,
      away: 3.30,
    },
    popular: true,
    hot: true,
  },
  {
    id: 'm4',
    sport: 'Basketball',
    league: 'NBA',
    leagueFlag: '🇺🇸',
    homeTeam: 'Lakers',
    awayTeam: 'Celtics',
    homeIcon: '🟡',
    awayIcon: '🟢',
    date: 'Auj. 02:30',
    markets: {
      home: 1.95,
      draw: null,
      away: 1.85,
    },
    popular: false,
    hot: true,
  },
  {
    id: 'm5',
    sport: 'Tennis',
    league: 'Roland Garros',
    leagueFlag: '🇫🇷',
    homeTeam: 'Djokovic',
    awayTeam: 'Alcaraz',
    homeIcon: '🎾',
    awayIcon: '🎾',
    date: 'Dem. 14:00',
    markets: {
      home: 1.75,
      draw: null,
      away: 2.05,
    },
    popular: true,
    hot: false,
  },
  {
    id: 'm6',
    sport: 'Football',
    league: 'La Liga',
    leagueFlag: '🇪🇸',
    homeTeam: 'Barcelona',
    awayTeam: 'Atletico Madrid',
    homeIcon: '🔵',
    awayIcon: '🔴',
    date: 'Sam. 18:30',
    markets: {
      home: 1.70,
      draw: 3.60,
      away: 4.80,
    },
    popular: false,
    hot: false,
  },
];

export const liveMatches = [
  {
    id: 'l1',
    sport: 'Football',
    league: 'Bundesliga',
    leagueFlag: '🇩🇪',
    homeTeam: 'Dortmund',
    awayTeam: 'Leverkusen',
    homeIcon: '🟡',
    awayIcon: '🔴',
    score: '1 - 0',
    minute: "67'",
    markets: {
      home: 1.45,
      draw: 4.50,
      away: 7.00,
    },
    hot: true,
  },
  {
    id: 'l2',
    sport: 'Basketball',
    league: 'NBA',
    leagueFlag: '🇺🇸',
    homeTeam: 'Warriors',
    awayTeam: 'Nets',
    homeIcon: '🟡',
    awayIcon: '⚫',
    score: '78 - 72',
    minute: "Q3 4:21",
    markets: {
      home: 1.30,
      draw: null,
      away: 3.20,
    },
    hot: false,
  },
  {
    id: 'l3',
    sport: 'Tennis',
    league: 'ATP Masters',
    leagueFlag: '🎾',
    homeTeam: 'Nadal',
    awayTeam: 'Medvedev',
    homeIcon: '🎾',
    awayIcon: '🎾',
    score: '6-4, 3-2',
    minute: "Set 2",
    markets: {
      home: 1.55,
      draw: null,
      away: 2.40,
    },
    hot: true,
  },
  {
    id: 'l4',
    sport: 'Football',
    league: 'Serie A',
    leagueFlag: '🇮🇹',
    homeTeam: 'Inter Milan',
    awayTeam: 'Juventus',
    homeIcon: '⚫',
    awayIcon: '⚪',
    score: '0 - 0',
    minute: "23'",
    markets: {
      home: 2.20,
      draw: 3.10,
      away: 3.40,
    },
    hot: false,
  },
];

export const allSportsMatches = [
  ...featuredMatches,
  {
    id: 's1',
    sport: 'Football',
    league: 'Bundesliga',
    leagueFlag: '🇩🇪',
    homeTeam: 'Bayern Munich',
    awayTeam: 'RB Leipzig',
    homeIcon: '🔴',
    awayIcon: '🔴',
    date: 'Sam. 15:30',
    markets: { home: 1.55, draw: 4.00, away: 5.50 },
    popular: false, hot: false,
  },
  {
    id: 's2',
    sport: 'eSports',
    league: 'CS2 - ESL Pro League',
    leagueFlag: '🎮',
    homeTeam: 'Natus Vincere',
    awayTeam: 'Astralis',
    homeIcon: '💛',
    awayIcon: '🔵',
    date: 'Auj. 18:00',
    markets: { home: 1.90, draw: null, away: 1.90 },
    popular: false, hot: true,
  },
  {
    id: 's3',
    sport: 'Football',
    league: 'Ligue 1',
    leagueFlag: '🇫🇷',
    homeTeam: 'Lyon',
    awayTeam: 'Monaco',
    homeIcon: '🔴',
    awayIcon: '🔴',
    date: 'Dim. 17:00',
    markets: { home: 2.60, draw: 3.20, away: 2.70 },
    popular: false, hot: false,
  },
];
